import GLightbox from 'glightbox';

export default class GalleryController {
    constructor() {
        this.gallery = null;
        this.items = [];
        this.subTemplate = require('../elements/templates/gallerySub.handlebars');

        // import( /* webpackChunkName: "modules/vimeo" */ '@vimeo/player').then(module => {
        //     window.Vimeo = { Player: module.default };
        // });
        this.init();
    }

    init() {
        document.querySelectorAll('[data-gallery]').forEach(item => {
            const { 
                gallerySrc,
                galleryType,
                galleryTitle,
                galleryYear,
                galleryCaption
            } = item.dataset;
            const galleryItem = {};
            
            if (galleryTitle || galleryYear || galleryCaption) {
                galleryItem.description = this.generateSub(item);
            }

            galleryItem.href = gallerySrc || item.querySelector(`[src]`).src;

            switch (galleryType) {
                case 'image':
                    galleryItem.type = 'image';
                break;
                case 'vimeovideo':
                    galleryItem.type = 'video';
                    galleryItem.source = 'vimeo';
                    break;
                case 'youtubevideo':
                    galleryItem.type = 'video';
                    galleryItem.source = 'youtube';
                break;
                case 'video':
                    galleryItem.type = 'video';
                    galleryItem.source = 'local';
                break;
            }

            this.items.push(galleryItem);
            const index = this.items.length - 1;

            item.addEventListener('click', e => {
                e.preventDefault();
                if (this.gallery) {
                    this.gallery.openAt(index);
                }
            });
        });

        this.gallery = GLightbox({
            elements: this.items,
            loop: true,
            plyr: {
                config: {
                    ratio: '16:9', // or '4:3'
                    muted: false,
                    hideControls: true,
                    youtube: {
                        noCookie: true,
                        rel: 0,
                        showinfo: 0,
                        iv_load_policy: 3
                    },
                    vimeo: {
                        byline: false,
                        portrait: false,
                        title: false,
                        speed: true,
                        transparent: false
                    }
                }
            }

            // prevHtml: `<svg class="sprite icon_link_arrow lg-prev"><use xlink:href="#icon_link_arrow" /></svg>`,
            // nextHtml: `<svg class="sprite icon_link_arrow lg-next"><use xlink:href="#icon_link_arrow" /></svg>`,
            // mobileSettings: {
            //     controls: true, 
            //     showCloseIcon: true, 
            // },
        });
    }

    generateSub(item) {
        let data = {
            title: item.dataset.galleryTitle || '',
            year: item.dataset.galleryYear || '',
            caption: item.dataset.galleryCaption || '',
        };
        
        return this.subTemplate(data);

        // const div = document.createElement('div');
        // div.classList.add('itemContent');
        // div.innerHTML = this.subTemplate(data);
        // return div;
    }

    // Useful when working with dynamic data
    resetGallery() {
        // this.items = [];
        // if (this.gallery) {
        //     this.gallery.destroy();
        //     this.gallery = null;
        // }
        // this.init();
    }
}